// src/metadata/constants.js
// @ts-check

/** Resolve a canonical base URL (origin only), with env fallbacks. */

const RAW_BASE =
  // Vite
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_BASE_URL) ||
  // CRA / Next / generic
  (typeof process !== 'undefined' && process.env &&
    (process.env.HERMES_BASE_URL || process.env.NEXT_PUBLIC_BASE_URL || process.env.REACT_APP_BASE_URL)) ||
  // Default
  'https://www.hermesreads.com';

let _BASE_ORIGIN = 'https://www.hermesreads.com';
try {
  // Ensure we store just the origin (no trailing path/query)
  _BASE_ORIGIN = new URL(RAW_BASE).origin;
} catch { /* keep default */ }

/** Canonical site origin. No trailing slash. */
export const BASE_URL = _BASE_ORIGIN;

/** Language & currency defaults. */
export const DEFAULT_LANG = 'en';
export const DEFAULT_CURRENCY = 'USD';

/** Brand / organization globals. */
export const ORGANIZATION_NAME = 'HermesReads';
export const ORGANIZATION_URL = `${BASE_URL}/`;
export const ORGANIZATION_LOGO = '/images/logo.png';
export const ORGANIZATION_LOGO_URL = `${BASE_URL}${ORGANIZATION_LOGO}`;
export const TWITTER_HANDLE = '@HermesReads';

/** Shared assets & dimensions. */
export const PLACEHOLDER_IMAGE = '/images/PlaceholderJPG.webp';
export const PLACEHOLDER_IMAGE_URL = `${BASE_URL}${PLACEHOLDER_IMAGE}`;
export const DEFAULT_OG_IMAGE = '/images/homepage-banner.jpg';
export const DEFAULT_OG_IMAGE_URL = `${BASE_URL}${DEFAULT_OG_IMAGE}`;
export const OG_IMAGE_WIDTH = 1200;
export const OG_IMAGE_HEIGHT = 630;

/** SERP-friendly clamp targets. */
export const TITLE_CLAMP = 60;
export const DESCRIPTION_CLAMP = 155;

/** Robots presets. */
export const ROBOTS_INDEX_APPEND = 'max-snippet:-1,max-image-preview:large';
export const ROBOTS_INDEX = `index,follow,${ROBOTS_INDEX_APPEND}`;
export const ROBOTS_NOINDEX = `noindex,follow,${ROBOTS_INDEX_APPEND}`;
export const ROBOTS_NOINDEX_NOFOLLOW = 'noindex,nofollow';

/** RTL languages. */
export const RTL_LANGS = Object.freeze(['ar', 'he', 'fa', 'ur', 'ku-Arab', 'ps', 'sd', 'yi']);

/** BCP-47 language -> OpenGraph underscore variant. */
export const OG_LOCALE = Object.freeze({
  en: 'en_US',
  sv: 'sv_SE',
  de: 'de_DE',
  fr: 'fr_FR',
  es: 'es_ES',
  fi: 'fi_FI',
  pt: 'pt_PT',
  ru: 'ru_RU',
  zh: 'zh_CN',
  pl: 'pl_PL',
  it: 'it_IT',
  da: 'da_DK',
});

/** Keep this derived to avoid drift with OG_LOCALE. */
export const SUPPORTED_LANGS = Object.freeze(Object.keys(OG_LOCALE));

/** Shared organization schema helper values. */
export const ORGANIZATION_SCHEMA = Object.freeze({
  '@type': 'Organization',
  name: ORGANIZATION_NAME,
  url: ORGANIZATION_URL,
  logo: {
    '@type': 'ImageObject',
    url: ORGANIZATION_LOGO_URL
  }
});